<script lang="ts">
import { modifiers } from "../store";

export let index: number;
export let key: string;
export let min: number|null = null;
export let max: number|null = null;
export let step: number|null = null;

</script>
<div class="form-group mb-3">
	<label for={`Modifiers${index}.${key}`} class="text-capitalize">{key}</label>
	<input type="number" class="form-control" id={`Modifiers${index}.${key}`} {min} {max} {step} bind:value={$modifiers[index][key]}>
</div>
